var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthnaOffBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1234,
    height: 339,
    viewBox: "0 0 1234 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24C0 10.7452 10.7452 0 24 0H138H208H1210C1223.25 0 1234 10.7452 1234 24V171C1234 184.255 1223.25 195 1210 195H258C230.386 195 208 217.386 208 245V261C208 280.33 192.33 296 173 296C153.67 296 138 280.33 138 261V229C138 210.222 122.778 195 104 195C85.2223 195 70 210.222 70 229V304C70 323.33 54.33 339 35 339C15.67 339 0 323.33 0 304V171V43V24Z",
    fill: "url(#paint0_linear_408_1842)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_408_1842",
    x1: 26.0704,
    y1: 52.3909,
    x2: 1309.1,
    y2: 801.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319327,
    stopColor: "#F84CDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904445,
    stopColor: "#FFE600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthnaOffBg);
export default __webpack_public_path__ + "static/media/ethna_off_bg.42d06741670ecf80c6d5d99cc232d9ff.svg";
export { ForwardRef as ReactComponent };